// extracted by mini-css-extract-plugin
export default {"btn":"LogOutButton_btn__Rhqep"};